import React, { FC } from 'react';

import { StyledBanner } from './BannerV2.styles';

type BannerV2Props = {
  className?: string;
  type?: 'warning' | 'minorwarn' | 'marketing' | 'informational' | 'error';
};

const BannerV2: FC<BannerV2Props> = ({ type = 'warning', className, children }) => {
  return (
    <StyledBanner className={className} type={type}>
      {children}
    </StyledBanner>
  );
};

export default BannerV2;
